var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CurrentPlanUsageItemWrapper } from '../styles';
import { PolarAngleAxis, RadialBarChart, RadialBar } from 'recharts';
var CurrentPlanUsageItem = function (_a) {
    var consumed = _a.consumed, available = _a.available;
    var data = [{ name: 'L1', value: consumed }];
    var circleSize = 150;
    var fill = Number(consumed / available) === 1
        ? '#EB5757'
        : Number(consumed / available) > 0.75
            ? '##F2994A'
            : '#82ca9d';
    return (_jsx(CurrentPlanUsageItemWrapper, { children: _jsxs(RadialBarChart, __assign({ width: circleSize, height: circleSize, cx: circleSize / 2, cy: circleSize / 2, innerRadius: 55, outerRadius: 75, data: data, startAngle: 90, endAngle: -270 }, { children: [_jsx(PolarAngleAxis, { type: "number", domain: [0, available], angleAxisId: 0, tick: false }), _jsx(RadialBar, { background: true, dataKey: "value", cornerRadius: circleSize / 2, fill: fill }), _jsxs("text", __assign({ x: circleSize / 2, y: circleSize / 2, textAnchor: "middle", dominantBaseline: "middle" }, { children: [consumed, "/", available] }))] })) }));
};
export default CurrentPlanUsageItem;
